import { memo } from 'react'

interface HistoryBadgeButtonProps {
  count: number
  isActive: boolean
  onClick: (e: React.MouseEvent) => void
}

export const HistoryBadgeButton = memo(function HistoryBadgeButton({
  count,
  isActive,
  onClick,
}: HistoryBadgeButtonProps) {
  return (
    <button
      data-testid="canvas-history-badge"
      onClick={onClick}
      className={`w-7 h-7 rounded ${
        isActive ? 'bg-black/60 ring-2 ring-white/70' : 'bg-black/60 hover:bg-black/80'
      } text-foreground flex items-center justify-center backdrop-blur-sm transition-colors relative`}
      title={`${count} versions - click to browse history`}
    >
      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span className="absolute -top-1 -right-1 min-w-[14px] h-[14px] rounded-full bg-foreground text-black text-xxs font-bold flex items-center justify-center px-0.5 leading-none">
        {count}
      </span>
    </button>
  )
})

HistoryBadgeButton.displayName = 'HistoryBadgeButton'
